import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';

import { UsersPlusIcon } from '@/components/icons/UsersPlusIcon';
import { EmptyListActionCard } from '@/components/lists/EmptyListActionCard';
import { HeaderList } from '@/components/lists/HeaderList/HeaderList';
import { RichListItem } from '@/components/lists/RichListItem/RichListItem';
import { useViewOnly } from '@/contexts/InteractionParadigm.context';
import { EmptyListEditEntityActionCard } from '@/modules/entities/components/EmptyListEditEntityActionCard';
import { EntitySubformCategory } from '@/modules/entities/EntitySubforms/entitySubformConfigs';

import { BusinessEntitySummaryData } from './BusinessEntityDetails.types';
import { getFormattedKeyPerson } from './BusinessEntityDetails.utils';

export function BusinessEntityKeyPeople(props: BusinessEntitySummaryData) {
  const isViewOnly = useViewOnly();
  const { keyPeople, keyPeopleNotes, onShowEditEntity } = props;

  useEffect(() => {
    if (!isViewOnly && (keyPeople || []).length > 0) {
      onShowEditEntity?.(true);
    } else {
      onShowEditEntity?.(false);
    }
  }, [isViewOnly, onShowEditEntity, keyPeople]);

  if (isViewOnly && !keyPeople?.length && !keyPeopleNotes) {
    return (
      <EmptyListActionCard
        icon={UsersPlusIcon}
        heading="No key people specified"
        description="No key people have been specified for this entity"
        hideButton
      />
    );
  }

  if (!isViewOnly && !keyPeople?.length) {
    return (
      <EmptyListEditEntityActionCard
        icon={UsersPlusIcon}
        heading="Specify key people"
        buttonText="Add key people"
        description="No key people have been specified for this entity"
        editSubformCategory={EntitySubformCategory.BUSINESS_ENTITY_DETAILS}
      />
    );
  }

  return (
    <Stack spacing={2}>
      {keyPeopleNotes && (
        <Typography variant="body-s" component="p">
          {keyPeopleNotes}
        </Typography>
      )}
      <HeaderList noItemsText="No key people specified">
        {keyPeople?.map((kp) => (
          <RichListItem key={kp.id} {...getFormattedKeyPerson(kp)} />
        )) ?? []}
      </HeaderList>
    </Stack>
  );
}
